import type { Piece } from '@blind-chess/shared';

export function pieceGlyph(piece: Piece): string {
  const map: Record<string, string> = {
    wk: '♔', wq: '♕', wr: '♖', wb: '♗', wn: '♘', wp: '♙',
    bk: '♚', bq: '♛', br: '♜', bb: '♝', bn: '♞', bp: '♟',
  };
  return map[`${piece.color}${piece.type}`] ?? '?';
}
